import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-78" data-mp="1ceqetqsvt3iv">
      <div className="mx-auto w-full max-w-2xl" data-id="element-79" data-mp="1ccdmcjphzark">
        <h2 className="text-center font-display text-[1.65rem] font-bold leading-tight text-navy sm:text-4xl" data-id="element-80" data-mp="2a2id6o3oeas1">
          Preguntas frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-81" data-mp="2512u31l26eca">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" data-id="element-82" data-mp="1v5hjwg5u67rg" data-mpi={i}>
                <h3 data-id="element-83" data-mp="oq76jb9u0qqs">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left text-sm font-semibold text-navy sm:text-base" data-id="element-84" data-mp="omje6fg4iadn">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-85" data-mp="1aor83twn7ccs" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-86" data-mp="16pidynxoxcgp">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-87" data-mp="s0dvd5mzh682">
                      <p className="px-4 pb-4 text-sm leading-relaxed text-navy/70 sm:text-base" data-id="element-88" data-mp="n080lglf33lr">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-9" data-id="element-89" data-mp="2fw28ygwab5kx">
          <CTAButton label="Resolver mis dudas comprando ahora" note="Garantía de 7 días · Pago único" data-id="element-90" data-mp="2fxd8u5mlzt6r" />
        </div>
      </div>
    </section>;
}